export class Option {
    name: string = "";
    text: string = "";
    explanation: string = "";
    value: any = "";
    iconName: string | undefined;
    selected: boolean;
    iconType: string = "svg";
    iconClass: string | undefined;

    _i18n?: Record<string, Record<string, string>>;

    /**
     * Stable lookup key into OPTION_LABEL_DEFAULTS. Set by OptionUtils.create()
     * for code-defined options so tier-2 translation defaults survive server
     * round-trip (server does not touch this field).
     */
    _defaultsKey?: string;

    constructor(name: string, text: string, explanation: string, value: any, iconName?: string, iconClass?: string) {
      this.text = text;
      this.explanation = explanation;
      this.value = value;
      this.selected = false;
      this.name = name;
      this.iconName = iconName;
      this.iconClass = iconClass;
    }
}
